// extracted by mini-css-extract-plugin
module.exports = {"action":"action___La9-_","nation_icon":"nation_icon___3pCn-"};